import axios from 'axios';
import config from '../config';

const authHeader = () => {
    const token = localStorage.getItem('sessiontoken');
    return { headers: { Authorization: `${token}` } };
};

const licenseService = {
    createPO: (payload) =>
        axios.post(`${config.hostname}/licenses/po`, payload, authHeader()),

    listPOs: (params = {}) =>
        axios.get(`${config.hostname}/licenses/po`, { ...authHeader(), params }),

    listAllConsumptions: (params = {}) =>
        axios.get(`${config.hostname}/licenses/logs`, { ...authHeader(), params }),

    getAssetStatus: (assetId, params = {}) =>
        axios.get(`${config.hostname}/licenses/status/${assetId}`, { ...authHeader(), params }),

    listLicensesForAsset: (assetId, params = {}) =>
        axios.get(`${config.hostname}/licenses/list/${assetId}`, { ...authHeader(), params }),

    consumeLicense: (payload) =>
        axios.post(`${config.hostname}/licenses/consume`, payload, authHeader()),

    // --- License groups ----------------------------------------------
    listGroups: () =>
        axios.get(`${config.hostname}/licenses/groups`, authHeader()),

    createGroup: (payload) =>
        axios.post(`${config.hostname}/licenses/groups`, payload, authHeader()),

    updateGroupMembership: (groupId, memberPropertyIds) =>
        axios.post(`${config.hostname}/licenses/groups/${groupId}/members`, { memberPropertyIds }, authHeader()),

    getGroupStatus: (groupId, params = {}) =>
        axios.get(`${config.hostname}/licenses/groups/${groupId}/status`, { ...authHeader(), params }),

    listLicensesForGroup: (groupId, params = {}) =>
        axios.get(`${config.hostname}/licenses/groups/${groupId}/list`, { ...authHeader(), params })
};

export default licenseService;
